import React, { useCallback, useState } from 'react'
import axios from 'lib/axios'
import Select from 'components/QuestionnaireRequest/AdminNew/components/Select'
import ToggleCheckbox from 'components/QuestionnaireRequest/AdminNew/components/checkbox'

const FORM_TYPES = [
  { 'value': 'generic', 'label': 'generic' },
  { 'value': 'lender', 'label': 'lender' },
  { 'value': 'attorney', 'label': 'attorney / due dilligence' },
  { 'value': 'appraiser', 'label': 'appraiser' },
  { 'value': 'other', 'label': 'other' },
]

const AcceptedFormTypes = ({
  buildingId,
  questionnaireAcceptedFormTypes,
  updateQuestionnaireAcceptedFormTypes,
  updating,
  setUpdating,
}) => {
  const onClose = useCallback(
    async (selectedItems) => {
      setUpdating(true)
      const url = `/buildings/${buildingId}/questionnaires/update_questionnaire_accepted_form_types`
      await axios.post(url, {
        questionnaire_accepted_form_types: selectedItems,
      })
      setUpdating(false)
      updateQuestionnaireAcceptedFormTypes(selectedItems)
    },
    [updateQuestionnaireAcceptedFormTypes, setUpdating]
  )

  return (
    <div className="dome-d-flex dome-flex-column">
      <span className="dome-p2 dome-color-med-grey">accepted form types</span>
      <div>
        <Select
          multiple={true}
          onClose={onClose}
          options={FORM_TYPES}
          defaultSelectedItems={questionnaireAcceptedFormTypes}
          disabled={updating}
          label="select acceptable form types"
          selectAll={true}
          selectAllDisplay="all form types"
          selectAllOptionLabel="select all form types"
        />
      </div>
    </div>
  )
}

const EnableCheckbox = ({ buildingId, enabled, updateEnabled, updating, setUpdating }) => {
  const changeValue = async (enabled) => {
    try {
      setUpdating(true)
      const url = `/buildings/${buildingId}/questionnaires/enable_limit_accepted_form_types`
      await axios.post(url, { limit_questionnaire_form_types: enabled ? 1 : 0 })
      updateEnabled(enabled)
    } catch (error) {
      console.log(error)
    } finally {
      setUpdating(false)
    }
  }

  return (
    <div className="dome-d-flex dome-align-start">
      <ToggleCheckbox
        label="limit accepted form types"
        defaultChecked={enabled}
        disabled={updating}
        onChange={(e) => changeValue(e.target.checked)}
      />
    </div>
  )
}

export default function LimitAcceptedFormTypes({
  buildingId,
  isLimitAcceptedFormTypesEnabled,
  updateLimitAcceptedFormTypes,
  questionnaireAcceptedFormTypes,
  updateQuestionnaireAcceptedFormTypes,
}) {
  const [updating, setUpdating] = useState(false)

  return (
    <div className="questionnaire-admin-general-row">
      <EnableCheckbox
        buildingId={buildingId}
        enabled={isLimitAcceptedFormTypesEnabled}
        updateEnabled={updateLimitAcceptedFormTypes}
        updating={updating}
        setUpdating={setUpdating}
      />
      {isLimitAcceptedFormTypesEnabled && (
        <AcceptedFormTypes
          buildingId={buildingId}
          questionnaireAcceptedFormTypes={questionnaireAcceptedFormTypes}
          updateQuestionnaireAcceptedFormTypes={updateQuestionnaireAcceptedFormTypes}
          updating={updating}
          setUpdating={setUpdating}
        />
      )}
    </div>
  )
}
